import {VueTelInput} from "vue-tel-input";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "course-learn-more-form",
    data() {
        return {
            payload: {
                fullName: '',
                email: '',
                phone: '',
            },
            isValidPhone: true,
            validationErrors: {
                phone: [],
                fullName: [],
                email: [],
            },
            show: false
        }
    },
    computed: {
        ...mapGetters({
            form: 'coursesFeedback/form',
            sent: 'coursesFeedback/sent',
            isLoading: 'coursesFeedback/loading',
            defaultLocale: 'setting/defaultLocale',
            messages: 'coursesFeedback/messages',
        })
    },
    components: {
        VueTelInput,
    },
    methods: {
        ...mapActions({
            sendFeedback: 'coursesFeedback/SEND_FEEDBACK_FORM',
            getFeedbackForm: 'coursesFeedback/GET_FEEDBACK_FORM',
        }),
        changePhoneInput(number, info) {
            this.isValidPhone = info.valid;
            if (this.isValidPhone) {
                this.payload.phone = info.number.e164.replace('+', '');
                this.validationErrors.phone = [];
            }
        },
        changeValidationPhone() {
            this.validationErrors.phone = [];
            if (this.payload.phone.length > 0) {
                if (!this.isValidPhone) {
                    this.validationErrors.phone.push(this.$t('enterCorrectPhone'))
                } else {
                    this.validationErrors.phone = [];
                }
            } else {
                this.validationErrors.phone.push(this.$t('validationRequired'))
            }
        },
        changeFullNameInput() {
            if (this.payload.fullName.length > 0) {
                this.validationErrors.fullName = [];
            }
        },
        changeEmailInput() {
            if (this.payload.email.length > 0) {
                this.validationErrors.email = [];
            }
        },
        getLocale() {
          return this.$route.params.lang || this.defaultLocale[0].locale;
        },
        submitForm() {
            this.validationErrors.fullName = [];
            this.validationErrors.email = [];
            this.changeValidationPhone();

            const payload = {
                course_id: this.form.courseId,
                package_id: this.form.packageId,
                form_id: this.form.id,
                full_name: this.payload.fullName,
                ...this.payload,
            }

            if (this.payload.fullName.length === 0) {
                this.validationErrors.fullName.push(this.$t('validationRequired'))
            }

            if (this.payload.email.length === 0) {
                this.validationErrors.email.push(this.$t('validationRequired'))
            }

            if (
                this.validationErrors.phone.length > 0 ||
                this.validationErrors.fullName.length > 0 ||
                this.validationErrors.email.length > 0
            ) {
                return;
            }
            this.sendFeedback(payload)
        },
        resetForm() {
            this.sent = false;
            this.payload = {
                fullName: '',
                    email: '',
                    phone: '',
            };
            this.isValidPhone = true;
            this.validationErrors = {
                phone: [],
                    fullName: [],
                    email: [],
            };
        }
    },
    mounted() {
        const data = {
            slug: this.$route.params.item,
            locale: this.getLocale()
        }
        this.getFeedbackForm(data);
    }
}